// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1Bpyl","card":"Cards_card__3UrWJ","infected":"Cards_infected__1ZFAf","recovered":"Cards_recovered__3VIen","deaths":"Cards_deaths__1HPZ8"};